import {FilterCategory, FilterCategoryType, FilterSets} from "@/components/filterDropdown/FilterDropdown.ts";
import {FilterDropdown} from "@/components/filterDropdown/FilterDropdown.tsx";
import {GQL_MAINTENANCE_SERVICES_FILTER_LIST, GQL_MAINTENANCE_TAGS_FILTER_LIST} from "@/lib/queries/maintenance.ts";
import {MaintenanceScheduleState, MaintenanceScheduleType} from "@/lib/types/maintenance.ts";

type MaintenanceSchedulesFiltersProps = {
  filterSets: FilterSets<FilterCategory>;
  onFilterSetChange: (filterSet: FilterSets<FilterCategory>) => void;
};

export const MaintenanceSchedulesFilters = ({filterSets, onFilterSetChange}: MaintenanceSchedulesFiltersProps) => {
  const filterFields: FilterCategory[] = [
    {
      key: "status",
      type: FilterCategoryType.ARRAY,
      display: "Status",
      options: [
        {
          key: MaintenanceScheduleState.IN_MAINTENANCE,
          display: "In Maintenance",
        },
        {
          key: MaintenanceScheduleState.PAUSED,
          display: "Paused",
        },
        {
          key: MaintenanceScheduleState.ACTIVE,
          display: "Scheduled",
        },
        {
          key: MaintenanceScheduleState.ENDED,
          display: "Ended",
        },
      ],
    },
    {
      key: "services",
      type: FilterCategoryType.GQL,
      display: "Checks",
      graphql: GQL_MAINTENANCE_SERVICES_FILTER_LIST,
      sorted: true,
    },
    {
      key: "tags",
      type: FilterCategoryType.GQL,
      display: "Tags",
      graphql: GQL_MAINTENANCE_TAGS_FILTER_LIST,
      sorted: true,
      matchMode: {enabled: true},
    },
    {
      key: "types",
      type: FilterCategoryType.ARRAY,
      display: "Recurrence",
      options: [
        {
          key: MaintenanceScheduleType.RRULE,
          display: "Recurring",
        },
        {
          key: MaintenanceScheduleType.ONE_OFF,
          display: "Non-Recurring",
        },
      ],
    },
  ];

  return <FilterDropdown categories={filterFields} appliedFilterSets={filterSets} onApply={onFilterSetChange} />;
};
